export const normalizeLocationAddress = (address) => {
  if (typeof address !== 'string') {
    return '';
  }

  return address.trim().toLowerCase().replace(/\s+/g, ' ');
};

const getLocationAddress = (location) => {
  if (!location) {
    return '';
  }

  if (typeof location === 'string') {
    return location;
  }

  return location.address || '';
};

export const haveSameLocationAddress = (firstLocation, secondLocation) => {
  const normalizedFirstAddress = normalizeLocationAddress(getLocationAddress(firstLocation));
  const normalizedSecondAddress = normalizeLocationAddress(getLocationAddress(secondLocation));

  if (!normalizedFirstAddress || !normalizedSecondAddress) {
    return false;
  }

  return normalizedFirstAddress === normalizedSecondAddress;
};
